// Web Development Course Data

const webDevelopmentCourse = {
  id: 'web-development',
  title: 'Web Development Training & Internship Program',
  shortTitle: 'Web Development',
  hero: {
    headline: 'Full-Stack Web Development Training and Internship - Certificate Program',
    subheadline: 'UK Industry-Microsoft Partnered Certified Program | Project Portfolio | Live Interactive Mentorship',
    description: 'Master modern web technologies and build real-world applications with Int-Elligence Tech Solutions Plc!',
    statistics: [
      { value: '75%', label: 'of UK businesses require web development skills', ref: 'Tech Nation 2024' },
      { value: '£35K-£65K', label: 'starting salaries for web developers', ref: 'IT Jobs Watch' },
      { value: '2.8x', label: 'more developer jobs than qualified candidates', ref: 'Stack Overflow' }
    ]
  },
  importantNotice: {
    title: '⚠️ IMPORTANT NOTICE',
    requirements: [
      'Treat this as a career accelerator, not just a certificate.',
      'Are prepared for challenging coding projects with deadlines.',
      'Proactively seek code reviews and 1:1 mentorship.'
    ],
    reason: 'Our mentors invest 30+ hours per student - we prioritize those serious about becoming professional developers.'
  },
  programHighlights: {
    duration: '3 Months',
    features: [
      {
        icon: '✅',
        title: '1. Full-Stack Training',
        description: 'Learn both frontend and backend development technologies'
      },
      {
        icon: '✅',
        title: '2. Weekly 1:1 Code Reviews',
        description: 'UK-based senior developers review your code weekly, providing feedback and mentorship'
      },
      {
        icon: '✅',
        title: '3. Industry Expert Mentors',
        description: 'Learn from developers working at top UK tech companies and startups'
      },
      {
        icon: '✅',
        title: '4. Microsoft-Partnered Certification',
        description: 'Industry-recognized certification to boost your career'
      },
      {
        icon: '✅',
        title: '5. Real Client Projects',
        description: 'Build production-ready applications for real clients'
      },
      {
        icon: '✅',
        title: '6. Career Opportunities',
        description: 'Top performers may join our development team'
      }
    ]
  },
  toolsCovered: [
    { name: 'HTML5 & CSS3', description: 'Modern web structure and styling', image: null },
    { name: 'JavaScript & React', description: 'Interactive frontend development', image: null },
    { name: 'Node.js & Express', description: 'Backend API development', image: null },
    { name: 'MongoDB & SQL', description: 'Database management and queries', image: null },
    { name: 'Git & Deployment', description: 'Version control and cloud deployment', image: null }
  ],
  whyThisProgram: [
    {
      title: 'High Demand Skills',
      description: 'Web development is one of the most in-demand tech skills in the UK market.'
    },
    {
      title: 'Industry-Standard Stack',
      description: 'Learn the MERN stack used by top UK tech companies.'
    },
    {
      title: 'Experienced Mentors',
      description: 'Learn from senior developers with years of industry experience.'
    },
    {
      title: 'Portfolio Development',
      description: 'Build 5+ production-ready projects for your portfolio.'
    },
    {
      title: 'Career Support',
      description: 'Get help with CV, GitHub profile, and interview preparation.'
    },
    {
      title: 'UK Market Focus',
      description: 'Training aligned with UK industry standards and requirements.'
    }
  ],
  programDetails: {
    overview: {
      title: 'Program Overview and Duration',
      description: 'Our Web Development Training and Internship - Certificate Program provides comprehensive full-stack development training. You\'ll gain access to our online learning platform with 3 months of intensive training:',
      phases: [
        {
          title: 'First 2 months',
          description: 'Master frontend and backend technologies through hands-on coding exercises, mini-projects, and code reviews with experienced developers.'
        },
        {
          title: 'Final month',
          description: 'Work on real client projects building e-commerce sites, web applications, and APIs - perfect for your developer portfolio.'
        }
      ]
    },
    modeOfDelivery: {
      title: 'Mode of Delivery',
      description: 'Fully remote program with self-paced learning, coding challenges, and weekly mentor sessions. This is a learning-focused unpaid program designed for skill development.'
    },
    commitment: {
      title: 'Commitment and Flexibility',
      description: 'We expect at least 8 hours per week of coding practice. Our self-directed structure allows you to learn at your pace while meeting project milestones.'
    },
    curriculum: {
      title: 'Curriculum and Hands-On Experience',
      description: 'The curriculum covers frontend, backend, and deployment:',
      points: [
        'Learn HTML, CSS, JavaScript, React, Node.js through interactive tutorials.',
        'Build mini-projects and receive code reviews from senior developers.',
        'Deploy full-stack applications to production in the final phase.'
      ]
    },
    mentorship: {
      title: 'Mentorship',
      description: 'Weekly 1:1 sessions (30-45 minutes) with UK-based senior developers for code reviews, debugging help, and career guidance.'
    },
    certification: {
      title: 'Certification and Credentials',
      description: 'Receive a Microsoft-Partnered Certificate upon completion, validating your full-stack development skills globally.'
    },
    careerAdvancement: {
      title: 'Career Advancement',
      description: 'Top performers may join our development team or work on client projects after completing the program.',
      additionalInfo: 'Our alumni have secured positions at startups, agencies, and tech companies across the UK.',
      careerPaths: 'Career paths include Frontend Developer, Backend Developer, Full-Stack Developer, React Developer, and Node.js Developer.'
    }
  },
  whoShouldApply: [
    {
      icon: '🔹',
      title: 'Aspiring Developers',
      description: 'Start your coding career with structured training.'
    },
    {
      icon: '🔹',
      title: 'Career Changers',
      description: 'Transition into tech with hands-on projects.'
    },
    {
      icon: '🔹',
      title: 'Students & Graduates',
      description: 'Build job-ready skills and portfolio projects.'
    }
  ],
  aluminiVideos: [
    {
      id: 1,
      name: "Yemisi",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/yemisi%20(2).mp4",
    },
    {
      id: 2,
      name: "Afifa",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/afifa.mp4",
    },
    {
      id: 3,
      name: "Obanla",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/obanla.mp4",
    },
  ],
  whyAlumniGetHired: [
    {
      icon: '✅',
      title: 'Real Projects',
      description: '5+ production applications in your portfolio'
    },
    {
      icon: '✅',
      title: 'Modern Stack',
      description: 'Learn React, Node.js, and cloud deployment'
    },
    {
      icon: '✅',
      title: 'Code Quality',
      description: 'Learn industry best practices and clean code'
    },
    {
      icon: '✅',
      title: 'Career Support',
      description: 'GitHub optimization, technical interview prep'
    }
  ],
  testimonialLink: 'https://share.google/wv45vd8NA35pedVmw',
  contactEmail: 'hr@int-elligence.co.uk',
  footerNote: 'The UK tech sector needs 250,000+ developers by 2025 - be one of them!'
};

export default webDevelopmentCourse;